module.exports = __webpack_public_path__ + "img/icon1.83ea21fc.png";